// extracted by mini-css-extract-plugin
export default {"list":"list_list__6efrT","row":"list_row__+Xu2J"};